import React, { Fragment } from "react";

import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label"
import Noc from 'components/presentation/Noc';
import Competitor from 'components/presentation/Competitor';
import { isVaultEvent } from "components/sports/gar/helper/GarHelpers";
import { getRscObject } from "helpers/rsc";


import { findArray, arraysEqual } from 'helpers/utils'
const GarPrevious = ({ data, apparatus }) => {
    const { breakPoint } = useViewport();
    const bIsVaultEvent = apparatus === "VT";
    const currents = data?.results?.items?.filter(
        item => item?.extendedResultsCurrent?.length > 0 &&
            item.extendedResultsCurrent?.find(extCurrtentItem =>
                extCurrtentItem.er_code === 'STAGE' &&
                extCurrtentItem.er_type === 'ER' &&
                extCurrtentItem.er_value === "LAST")
    )
    let ret = currents.map((item, key) => {
        const extendedResults = ((item?.extendedResults && item.extendedResults.length > 0))
            ? item.extendedResultsCurrent
            : undefined

        const posFirtsColumn = findArray(extendedResults, { er_type: ['ER'], er_code: ['DIFFICULTY'], er_pos: ["1"] }) ? true : false;
        let hasSecondVault = findArray(extendedResults, { er_type: ['ER'], er_code: ['DIFFICULTY'], er_pos: ["2"] }) ? true : false;
        const dificulty = findArray(extendedResults, { er_type: ['ER'], er_code: ['DIFFICULTY'], ...(posFirtsColumn && { er_pos: ["1"] }) })?.er_value
        const execution = findArray(extendedResults, { er_type: ['ER'], er_code: ['EXECUTION'], ...(posFirtsColumn && { er_pos: ["1"] }) })?.er_value
        const penalty = findArray(extendedResults, { er_type: ['ER'], er_code: ['PENALTY'], ...(posFirtsColumn && { er_pos: ["1"] }) }).er_value
        let score = findArray(extendedResults, { er_type: ['ER'], er_code: ['SCORE'], ...(posFirtsColumn && { er_pos: ["1"] }) })?.er_value

        const dificulty2 = findArray(extendedResults, { er_type: ['ER'], er_code: ['DIFFICULTY'], er_pos: ['2'] })?.er_value
        const execution2 = findArray(extendedResults, { er_type: ['ER'], er_code: ['EXECUTION'], er_pos: ['2'] })?.er_value
        const penalty2 = findArray(extendedResults, { er_type: ['ER'], er_code: ['PENALTY'], er_pos: ['2'] })?.er_value
        const score2 = findArray(extendedResults, { er_type: ['ER'], er_code: ['SCORE'], er_pos: ['2'] })?.er_value

        const scoreValue = (item.resultType === 'IRM')
            ? item?.resultIrm
            : item.resultData

        // let hasSecondVault = score2//findArray(item?.eventUnitEntries, { eue_code: ['SECOND_VAULT'], eue_type: ['EUE'] })?.eue_value === 'Y' ? true : false

        return (
            <Fragment key={`GarPrevious-${key}`}>
                <div><h6 className="text-dark"><Label data="HeaderPreviousCompetitor" /></h6></div>
                <div className="title d-flex flex-row">
                    <div className="d-flex align-items-center justify-content-end w-5 me-2"><Label data="HeaderBib" /></div>
                    <div className={`d-flex align-items-center justify-content-start  ${hasSecondVault ? "w-40 " : "w-50"} ms-2`}><Label data="HeaderName" /></div>
                    {
                        !bIsVaultEvent ?
                            <div className="w-25 d-flex align-items-center justify-content-center"><Label data="HeaderApparatus" /></div>
                            : <>
                                <div className="w-15 d-flex align-items-center justify-content-start ms-2"></div>
                                <div className="w-10 d-flex align-items-center justify-content-end me-2"><Label data="HeaderVault" />:1</div>
                            </>
                    }



                    {hasSecondVault && <div className="w-10 d-flex align-items-center justify-content-end me-2"><Label data="HeaderVault" />:2</div>}
                    <div className="w-10 d-flex align-items-center justify-content-end me-2"><Label data="HeaderScore" /></div>
                    <div className="w-10 d-flex align-items-center justify-content-end me-2"><Label data="HeaderRank" /></div>
                </div>

                <div className="d-flex flex-row border">
                    <div className="d-flex align-items-center justify-content-end w-5 me-2">{item?.bib}</div>
                    <div className={`d-flex align-items-center justify-content-start  ${hasSecondVault ? "w-40 " : "w-50"} ms-2`}>
                        <Noc {...item?.participant?.organisation} />
                        <Competitor
                            hidePicture={true}
                            nolink={true}
                            {...item.participant}
                        //guide={guide}
                        //showGuide={showGuide}
                        //disciplineClass={medicalClass}
                        />
                    </div>
                    <div className="d-flex flex-column w-15 justify-content-start ms-2">
                        <div className="mirs-cell"><Label data="HeaderDifficulty" /></div>
                        <div className="mirs-cell"><Label data="HeaderExecution" /></div>
                        <div className="mirs-cell"><Label data="HeaderPenalty" /></div>
                        <div className="mirs-cell"><Label data="HeaderScore" /></div>
                    </div>
                    <div className="d-flex flex-column w-10 me-2">
                        <div className="d-flex justify-content-end">{dificulty}</div>
                        <div className="d-flex justify-content-end">{execution}</div>
                        <div className="d-flex justify-content-end">{penalty}</div>
                        <div className="d-flex justify-content-end">{score}</div>
                    </div>

                    {hasSecondVault && <div className="d-flex flex-column w-10 justify-content-end me-2">
                        <div className="d-flex justify-content-end">{dificulty2}</div>
                        <div className="d-flex justify-content-end">{execution2}</div>
                        <div className="d-flex justify-content-end">{penalty2}</div>
                        <div className="d-flex justify-content-end">{score2}</div>
                    </div>}

                    <div className="d-flex align-items-center justify-content-end w-10 me-2"><b>{scoreValue}</b></div>
                    <div className="d-flex align-items-center justify-content-end w-10 me-2"><b>{item.resultRank}</b></div>
                </div>
            </Fragment>)
    })


    return (
        <div className="mb-4">
            {ret}
        </div>
    );
}
export default GarPrevious;